module.exports = __webpack_public_path__ + "static/media/TopDelivery2_5.773757b1.png";